var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickcircleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C8.96744 40 0 31.0326 0 20C0 8.96744 8.96744 0 20 0C31.0326 0 40 8.96744 40 20C40 31.0326 31.0326 40 20 40ZM20 2.7907C10.5116 2.7907 2.7907 10.5116 2.7907 20C2.7907 29.4884 10.5116 37.2093 20 37.2093C29.4884 37.2093 37.2093 29.4884 37.2093 20C37.2093 10.5116 29.4884 2.7907 20 2.7907Z",
    fill: "#8DC95E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3571 26.6611C16.985 26.6611 16.6315 26.5122 16.371 26.2518L11.1058 20.9866C10.5663 20.4471 10.5663 19.5541 11.1058 19.0145C11.6454 18.475 12.5384 18.475 13.0779 19.0145L17.3571 23.2936L26.9199 13.7308C27.4594 13.1913 28.3524 13.1913 28.892 13.7308C29.4315 14.2704 29.4315 15.1634 28.892 15.7029L18.3431 26.2518C18.0827 26.5122 17.7292 26.6611 17.3571 26.6611Z",
    fill: "#8DC95E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickcircleIcon);
export default __webpack_public_path__ + "static/media/tick circle_icon.64adb6532d57e6a100fe6921ee6f5d0d.svg";
export { ForwardRef as ReactComponent };